import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/jpg/mock-video-mobile.jpg'
import _imports_1 from '@/assets/images/jpg/mock-video.jpg'
import _imports_2 from '@/assets/video/mobile_banner_video.mp4'
import _imports_3 from '@/assets/video/desktop_banner_video.mp4'


const _hoisted_1 = _imports_0
const _hoisted_2 = { class: "banner-block-wrapper" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "banner-block" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("picture", { class: "image-wrapper image" }, [
  /*#__PURE__*/_createElementVNode("source", {
    srcset: _hoisted_1,
    media: "(max-width:660px)"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "banner"
  })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "video-wrapper"
}
const _hoisted_7 = {
  key: 0,
  src: _imports_2,
  type: "video/mp4"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_3,
  type: "video/mp4"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "text" }
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_2, [
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_ctx.preview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("video", {
                class: "video",
                autoplay: "",
                muted: "",
                playsinline: "",
                onCanplaythrough: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkVideo && _ctx.checkVideo(...args)))
              }, [
                (_ctx.isMobile)
                  ? (_openBlock(), _createElementBlock("source", _hoisted_7))
                  : (_openBlock(), _createElementBlock("source", _hoisted_8))
              ], 32)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["content", {animation:_ctx.play}])
        }, [
          _createElementVNode("h1", {
            class: "title",
            innerHTML: _ctx.pageData['topBannerTitle']
          }, null, 8, _hoisted_9),
          _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.pageData['topBannerSubTitle']), 1),
          _createElementVNode("a", {
            target: "_blank",
            href: _ctx.pageData['topBannerLink'],
            class: "btn btn-blue"
          }, _toDisplayString(_ctx.pageData['topBannerButton']), 9, _hoisted_11)
        ], 2)
      ])
    ])
  ]))
}